import clsx from "clsx";
import { SingleDesignationDesignationAttribute } from "react-migration/domains/constraints/typings/applicationTypes/SingleDesignation";
import { AttributeRendersMap } from "./types";

function renderRagAttribute(attribute: SingleDesignationDesignationAttribute) {
  const value = attribute.value;

  if (!value) {
    return null;
  }

  const color = {
    RED: "bg-red-500",
    AMBER: "bg-amber-500",
    GREEN: "bg-green-500",
  }[value.toUpperCase()];

  return (
    <div className="flex items-center gap-1">
      {color && <div className={clsx("w-3 h-3 rounded-full", color)} title={value} />}
      <span className="text-sm font-medium capitalize">{value.toLowerCase()}</span>
    </div>
  );
}
const renderMwAttribute = ({ value }: SingleDesignationDesignationAttribute) => `${value} MW`;
const renderMvaAttribute = ({ value }: SingleDesignationDesignationAttribute) => `${value} MVA`;
const renderKvaAttribute = ({ value }: SingleDesignationDesignationAttribute) => `${value} kVA`;
const renderKVAttribute = ({ value }: SingleDesignationDesignationAttribute) => `${value} kV`;
const renderVAttribute = ({ value }: SingleDesignationDesignationAttribute) => `${value} V`;

export const SUBSTATION_ATTRIBUTE_RENDERERS: AttributeRendersMap = {
  demand_rag: renderRagAttribute,
  generation_rag: renderRagAttribute,
  rag_status: renderRagAttribute,

  capacity_mva: renderMvaAttribute,
  demand_headroom_mva: renderMvaAttribute,
  generation_headroom_mva: renderMvaAttribute,
  connected_generation_mva: renderMvaAttribute,
  demand_mva: renderMvaAttribute,
  generation_mva: renderMvaAttribute,
  max_load_mva: renderMvaAttribute,
  nameplate_rating_mva: renderMvaAttribute,

  capacity_mw: renderMwAttribute,
  demand_headroom_mw: renderMwAttribute,
  demand_mw: renderMwAttribute,
  firm_capacity_summer_mw: renderMwAttribute,
  firm_capacity_winter_mw: renderMwAttribute,
  generation_connected_mw: renderMwAttribute,
  generation_contracted_mw: renderMwAttribute,
  generation_headroom_mw: renderMwAttribute,
  battery_storage_headroom_mw: renderMwAttribute,
  demand_headroom_non_firm_mw: renderMwAttribute,
  generation_headroom_hv_synchronous_mw: renderMwAttribute,
  generation_headroom_lv_synchronous_mw: renderMwAttribute,

  kva_rating: renderKvaAttribute,
  kva_rating_max: renderKvaAttribute,
  kva_rating_min: renderKvaAttribute,
  kva_ratings: renderKvaAttribute,

  voltage_kv: renderKVAttribute,
  voltage_v: renderVAttribute,
  primary_voltage_kv: renderKVAttribute,
  primary_voltage_v: renderVAttribute,
  downstream_voltage_kv: renderKVAttribute,
  downstream_voltage_v: renderVAttribute,
};
